var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"canvasContainer",staticClass:"canvas-container"},[(_vm.loaded)?_c('canvas',{ref:"canvas",attrs:{"width":_vm.canvasSize[0],"height":_vm.canvasSize[1]}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }